import { constructFrom as e } from "./constructFrom.js";
import { toDate as a } from "./toDate.js";
function u(r, o) {
  const t = a(r);
  return isNaN(+t) ? e(r, NaN) : (t.setFullYear(o), t);
}
export {
  u as default,
  u as setYear
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/date-fns@3.6.0/~/date-fns/setYear.js
// module id = 856
// module chunks = 41